import {
    Datagrid,
    List,
    ImageField,
    TextField,
    FunctionField,
    Button, TextInput, SelectInput, ReferenceInput, AutocompleteInput, TopToolbar, FilterButton, DateField
} from "react-admin";
import React from "react";
import { Link } from 'react-router-dom';

const handleRowClick = (id, resource, record) => {
    const courseId = record.id.split('/').pop();
    const filter = JSON.stringify({ course: courseId });
    return `/videos?filter=${filter}`;
};

const url = process.env.REACT_APP_PRODUCTION_FRONTEND_URL;
const filters = [
    <TextInput label="Title" source="title" />,
    <ReferenceInput reference="categories" source="category">
        <AutocompleteInput optionText="title" filterToQuery={q => ({ title: q || '' })} />
    </ReferenceInput>,
    <TextInput label="Instructor" source="instructor" />,
    <SelectInput source="certificate" label="Has Certificate" choices={[
        { id: '1', name: 'Yes' },
        { id: 'no', name: 'No' },
    ]} />
];

const ListActions = () => (
    <TopToolbar>
        <FilterButton/>
    </TopToolbar>
);

export const CourseList = () => (
    <List actions={<ListActions/>} filters={filters}>
        <Datagrid bulkActionButtons={false} rowClick={handleRowClick}>
            <ImageField source="s3Ref" label="Image" sortable={false} />
            <TextField source="title" />
            <FunctionField
                source="slug"
                render={record => <a target="_blank" href={`${url}/eg/single/${record.slug}`}>{record.slug}</a>}
                sortable={false}
            />
            <TextField source="categoryTitle" label="Category" sortable={false} />
            <TextField source="instructorName" label="Instructor" sortable={false} />
            <FunctionField
                source="certificate"
                render={
                    record =>
                        record.certificate ?
                            <i className="fa-solid fa-check"></i> :
                            <i className="fa-solid fa-xmark"></i>}
            />
            <DateField source="createdAt" label="Created At" />
            <>
                <FunctionField
                    label="Hello"
                    render=
                        {
                        record =>
                            <Button
                                color="primary"
                                component={Link}
                                to={{
                                    pathname: '/videos',
                                    search: `filter=${JSON.stringify({course: record.id.split('/').pop()})}`,
                                }}
                            >
                                <i className="fa-solid fa-video"></i>
                            </Button>

                        }
                />
            </>
        </Datagrid>
    </List>
);
